import { createContext, useContext } from "react";
import { ITypesCharacteristicsViewContext } from "./types";

export const TypesCharacteristicsViewContext = createContext<ITypesCharacteristicsViewContext | null>(
  null
);

export const useTypesCharacteristicsViewContext = () => {
  const context = useContext(TypesCharacteristicsViewContext);
  if (context === null) {
    throw new Error("useContext must be inside a Provider with a value");
  }
  return context;
};
